import { tagAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import {
  buttonSizes,
  tagVariantClickable,
  tagVariantOutline,
  tagVariantSolid,
  tagVariantSubtle,
} from "@/theme/helpers";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tagAnatomy.keys,
);

export const TagTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      fontWeight: "normal",
    },
  },
  sizes: {
    "2xs": {
      container: {
        px: 2,
        py: "auto",
        borderRadius: "base",
      },
    },
    "2xsCompact": {
      container: {
        borderRadius: "base",
      },
    },
    xs: {
      container: {
        minH: buttonSizes.xs.h,
        fontSize: buttonSizes.sm.fontSize,
        px: 2,
        py: "auto",
        borderRadius: "md",
      },
    },
    xsCompact: {
      container: {
        fontSize: buttonSizes.sm.fontSize,
        borderRadius: "md",
      },
    },
    sm: {
      container: {
        minH: buttonSizes.sm.h,
        fontSize: buttonSizes.sm.fontSize,
        px: 3,
        py: "auto",
        borderRadius: "md",
      },
    },
    smCompact: {
      container: {
        fontSize: buttonSizes.sm.fontSize,
        borderRadius: "md",
      },
    },
    md: {
      container: {
        minH: buttonSizes.md.h,
        px: 4,
        py: "auto",
      },
    },
    mdCompact: {
      // keeping this here to now to not break programmtic sizing (explicit size + compact flag)
    },
    lg: {
      container: {
        minH: buttonSizes.lg.h,
        py: "auto",
      },
    },
    lgCompact: {
      // keeping this here to now to not break programmtic sizing (explicit size + compact flag)
    },
  },
  variants: {
    solid: (props) => ({
      container: tagVariantSolid(props),
    }),
    subtle: (props) => ({
      container: tagVariantSubtle(props),
    }),
    outline: (props) => ({
      container: tagVariantOutline(props),
    }),
    clickable: (props) => ({
      container: tagVariantClickable(props),
    }),
    unstyled: {
      container: {
        borderRadius: 0,
      },
    },
  },
});
